<ph-stack>
    <ph-alert status="information">This is the only time these codes will be shown.</ph-alert>

    <ph-columns tiles min="160px">
        <code *ngFor="let code of codes; trackBy: trackByCode" class="code">{{ code }}</code>
    </ph-columns>

    <ph-actions align="start">
        <ph-button variant="secondary"
                   mode="filled"
                   size="small"
                   icon="copy"
                   e2eId="recovery-codes-copy"
                   [copyToClipboard]="codesBlock"
                   copySuccessTitle="Recovery codes copied"
                   copySuccessMessage="Your recovery codes were copied to your clipboard.">Copy all</ph-button>
        <ph-button variant="secondary"
                   mode="filled"
                   size="small"
                   icon="download-simple"
                   e2eId="recovery-codes-download"
                   (click)="download()">Download</ph-button>
        <ph-button variant="secondary"
                   mode="filled"
                   size="small"
                   icon="printer"
                   e2eId="recovery-codes-print"
                   (click)="print()">Print</ph-button>
    </ph-actions>

    <ph-divider></ph-divider>

    <ph-field inline align="start" boxed>
        <ph-checkbox [id]="acknowledgeId"
                     e2eId="recovery-codes-acknowledge"
                     aria-label="I have saved my recovery codes somewhere safe"
                     [checked]="acknowledged"
                     (ph-change)="onAcknowledgedChange($event.detail)"></ph-checkbox>
        <ph-field>
            <ph-label [attr.for]="acknowledgeId">I have saved my recovery codes somewhere safe</ph-label>
            <ph-hint>Each code signs you in once. Generating a new set replaces all of them.</ph-hint>
        </ph-field>
    </ph-field>
</ph-stack>

<!-- Print source for the action above (SD-8983). Hidden on screen and never rendered to the
     user directly: PrintService copies this container's INNER HTML into a print popup, so the
     container's own `display: none` does not suppress the output — only the children travel.
     That is also why the child styles live at the top level of the SCSS rather than nested
     under `.print-source`: the container does not exist in the popup, so a nested selector
     would never match there. -->
<div [id]="printId" class="print-source">
    <h1 class="print-heading">{{ 'PayHOA recovery codes' }}</h1>

    <p class="print-meta" *ngIf="accountEmail">{{ 'Account: ' }}{{ accountEmail }}</p>
    <p class="print-meta">{{ 'Generated: ' }}{{ generatedAt | legfiDate:'MMMM D, YYYY' }}</p>

    <ul class="print-codes">
        <li *ngFor="let code of codes; trackBy: trackByCode">{{ code }}</li>
    </ul>

    <p class="print-note">
        {{ 'Each code can be used once. Generating a new set invalidates every code on this sheet.' }}
    </p>
</div>
